module.exports = __webpack_public_path__ + "assets/img/lucky-1.edbe2017.png";